<div class="card-preloader" *ngIf="isLoading">
    <div class="card-status">
        <div class="spinner-border text-primary">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>